import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AuthService } from '@pg-app/core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogSetTimeoutComponent } from '@pg-app/common/dialog-set-timeout/dialog-set-timeout.component';
import { environment } from '@pg-env/environment';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private isSetUp = false;
  constructor(
    private idle: Idle,
    private authenticationService: AuthService,
    private dialog: MatDialog
  ) {
    this.setup();
  }

  isServiceRunning() {
    return this.idle.isRunning();
  }

  startIdleSvc() {
    if (this.idle.isRunning()) {
      this.idle.stop();
    }
    this.idle.watch();
  }

  stopIdleSvc() {
    this.idle.stop();
  }

  private setup() {
    if (!this.isSetUp) {
      const idleStartSec = environment.idleSec;
      const timeoutPeriodSec = environment.timeoutSec;

      this.idle.setIdle(idleStartSec);
      this.idle.setTimeout(timeoutPeriodSec);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      // Affter 15 minutes without do anything in DOM
      this.idle.onIdleStart.subscribe(() => {
        const dialogref = this.dialog.open(DialogSetTimeoutComponent, {
          disableClose: true
        });

        dialogref.afterClosed().subscribe(result => {
          if (result) {
            this.idle.watch();
          }
          if (!result) {
            this.authenticationService.logout();
            this.dialog.closeAll();
          }
        });
      });
      this.isSetUp = true;
    }
  }
}
